import { render, staticRenderFns } from "./RedemptionsCard.vue?vue&type=template&id=2dd3b9af&scoped=true&"
import script from "./RedemptionsCard.vue?vue&type=script&lang=js&"
export * from "./RedemptionsCard.vue?vue&type=script&lang=js&"
import style0 from "./RedemptionsCard.vue?vue&type=style&index=0&id=2dd3b9af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd3b9af",
  null
  
)

export default component.exports